import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-one',
  templateUrl: './theme-one.component.html',
  styleUrls: ['./theme-one.component.scss']
})
export class ThemeOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
